import { useAppState } from '@/ui/AppState';
import { navigate } from '@/ui/router';
import type { SyncState } from '@/sync/client';

const LOOK: Record<SyncState, { icon: string; label: string; color: string }> = {
  synced: { icon: '●', label: 'Synced', color: 'var(--correct)' },
  syncing: { icon: '◌', label: 'Syncing', color: 'var(--accent)' },
  pending: { icon: '◐', label: 'Pending', color: 'var(--flag-check)' },
  offline: { icon: '○', label: 'Offline', color: 'var(--text-faint)' },
  'signed-out': { icon: '○', label: 'Local only', color: 'var(--text-faint)' },
  error: { icon: '▲', label: 'Sync error', color: 'var(--incorrect)' },
};

export function SyncIndicator() {
  const { syncState, pending, syncNow } = useAppState();
  const look = LOOK[syncState];

  const title =
    syncState === 'pending'
      ? `${pending} change${pending === 1 ? '' : 's'} waiting to sync`
      : syncState === 'signed-out'
        ? 'Not signed in — everything is saved on this device'
        : look.label;

  return (
    <button
      className="icon-btn"
      title={title}
      aria-label={title}
      onClick={() => {
        if (syncState === 'signed-out' || syncState === 'error') navigate('/settings');
        else void syncNow();
      }}
      style={{ color: look.color }}
    >
      <span aria-hidden="true">{look.icon}</span>
    </button>
  );
}
